import React from "react";

const RouteFallback = () => (
  <div className="ib-route-fallback" role="status" aria-live="polite">
    <div className="ib-route-fallback-spinner" aria-hidden="true" />
    <span className="ib-route-fallback-text">Loading...</span>
  </div>
);

export default RouteFallback;
